import type React from "react";
import { CustomCheckbox } from "~/components/ui/check_Box";
import styles from "../../index.module.scss";
import type { BooleanFieldComponentProps } from "../../types";

const GroupSelectOptions: React.FC<BooleanFieldComponentProps> = ({
  options,
  handleBooleanOptionChange,
  isReadOnly,
}) => {
  // 選択オプション
  // USER_SELECT/ORGANIZATION_SELECT/GROUP_SELECTは
  // サンプルレコード生成時にLLMが有効な値を生成できないため、必須設定を除外
  const groupSelectOptions = [{ key: "noLabel", label: "フィールド名を表示しない" }];

  return (
    <>
      {/* チェックボックスオプション */}
      {groupSelectOptions.map((option) => (
        <div key={option.key} className={styles["form-group"]}>
          <CustomCheckbox
            label={option.label}
            checked={options[option.key] || false}
            onChange={(value) => handleBooleanOptionChange(option.key, value)}
            disabled={isReadOnly || false}
          />
        </div>
      ))}
    </>
  );
};

export default GroupSelectOptions;
